import NewAction from "./NewAction"
const Dialogs = {
    NewAction
}
export default Dialogs;